import {Swiper} from 'swiper';
import {Autoplay, Pagination} from 'swiper/modules';

Swiper.use([Autoplay, Pagination]);

const banners = document.querySelectorAll('.banner-slider.swiper');

banners.forEach(banner => {
  new Swiper(banner, {
    slidesPerView: 1,
    autoHeight: true,
    loop: true,
    slideToClickedSlide: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".banner-slider__pagination",
      clickable: true,
    },
  });
});
